/**
 * Stable CSS class names for E2E — LCW Money (wallet) page.
 */
export const LCWMONEY = {
    page: 'lcw-money-page',
    breadcrumbSection: 'lcw-money-page__breadcrumb-section',
    toolbarWrap: 'lcw-money-page__toolbar',
    searchComposite: 'lcw-money-page__search-composite',
    inputSelectSearchType: 'lcw-money-page-input--select-search-type',
    inputTextSearch: 'lcw-money-page-input--text-search',
    inputButtonSearch: 'lcw-money-page-input--button-search',
    inputButtonCashInOut: 'lcw-money-page-input--button-cash-in-out',
    loadingSection: 'lcw-money-page__loading-section',
    balanceBannerWrap: 'lcw-money-page__balance-banner',
    balanceBannerTitle: 'lcw-money-page__balance-title',
    gridWrap: 'lcw-money-page__grid-wrap',
    emptyStateWrap: 'lcw-money-page__empty-state-wrap',
    datagridAmountChip: 'lcw-money-datagrid-cell--amount-chip',

    cashDialogPaper: 'lcw-money-cash-dialog',
    cashDialogTitle: 'lcw-money-cash-dialog__title',
    cashDialogProgressWrap: 'lcw-money-cash-dialog__progress-wrap',
    cashDialogContent: 'lcw-money-cash-dialog__content',
    cashAmountFieldWrap: 'lcw-money-cash-dialog__amount-field-wrap',
    inputNumericCashAmount: 'lcw-money-cash-dialog-input--numeric-amount',
    inputTextCashDescription: 'lcw-money-cash-dialog-input--text-description',
    inputTextCashReference: 'lcw-money-cash-dialog-input--text-reference',
    cashRadioWrap: 'lcw-money-cash-dialog__radio-wrap',
    inputRadioCashAdd: 'lcw-money-cash-dialog-input--radio-add',
    inputRadioCashRemove: 'lcw-money-cash-dialog-input--radio-remove',
    cashDialogActions: 'lcw-money-cash-dialog__actions',
    inputButtonCashSave: 'lcw-money-cash-dialog-input--button-save',
    inputButtonCashCancel: 'lcw-money-cash-dialog-input--button-cancel',
} as const;

export const lcwMoneyCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
